<template>
  <div id="offers" :style="{ backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee' }">
    <header-o :model="headerData"></header-o>
    <div
      class="margin-vertical-10 offer-card"
      style="
        border-radius: 5px;
        color: black;
        margin-right: 15px;
        margin-left: 15px;
        margin-top: -185px;
      "
    >
      <div
        class="bg-light padding-horizontal-15 pos-rel box-shadow border-min"
        style="border-radius: 10px"
        :class="[isInviteEarn || isChallenge ? 'margin-bottom-90' : 'margin-bottom-10']"
        :style="{
          minHeight: isInviteEarn ? '74vh' : '60vh',
          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff'
        }"
        v-if="!isEmpty(offerData)"
      >
        <div class="margin-bottom-10" style="margin-top: 15px;">
          <CheckInIcon class="mb-img" v-if="isCheckIn" />
          <InviteIcon class="mb-img" v-else-if="isInviteEarn" />
          <GameZoneIcon class="mb-img" v-else-if="isGameZone" />
          <ChallengesIcon
            class="margin-bottom-10"
            v-else-if="offerData.offer_type_code.includes('daily_offer')"
          />
          <div style="font-size: 19px; font-weight: 600;" class="margin-bottom-20 padding-vertical-20 offer-title">
            {{ stripHTML(offerData.title) }}
          </div>
          <div
            style="font-size: 14px;"
            class="margin-bottom-20 padding-vertical-20 word-break offer-description"
            v-html="offerData.description"
          ></div>
          <img
            class="w85"
            :src="offerData.image_url"
            v-if="isCheckIn && offerData.image_url && !offerData.image_url.includes('default_checkin_offer.png')"
          />
          <img class="w50" :src="offerData.image_url" v-else-if="isCheckIn" />
          <img class="w85" :src="offerData.image_url" v-if="offerData.offer_type_title.includes('Challenges')" />
          <div
            class="text-left text-regular align-hor"
            style="padding: 8px 0px 12px 30px"
            v-if="offerData.offer_type_title.includes('Challenges')"
          >
            <div class="w5">
              <svg xmlns="http://www.w3.org/2000/svg" width="13.349" height="19.325" viewBox="0 0 13.349 19.325">
                <g id="Group_338" data-name="Group 338" transform="translate(0 0)">
                  <path
                    id="Path_520"
                    data-name="Path 520"
                    d="M-349.536-103.127c.523.146.66.329.66.877v.8h-13.338a10.253,10.253,0,0,1,.008-1.042.674.674,0,0,1,.6-.611c.1-.6.148-1.191.294-1.758a7.854,7.854,0,0,1,2.841-4.205c.254-.2.523-.391.794-.572a1.705,1.705,0,0,0,0-2.943,8.9,8.9,0,0,1-2.976-3.12,7.015,7.015,0,0,1-.9-3.282c0-.041-.006-.082-.009-.121a.762.762,0,0,1-.659-.894v-.777H-348.9c0,.382.028.77-.009,1.151-.028.284-.239.424-.632.527a7.029,7.029,0,0,1-.4,2.282,8.432,8.432,0,0,1-3.482,4.235,1.708,1.708,0,0,0-.79,1.1,1.683,1.683,0,0,0,.77,1.816,9.2,9.2,0,0,1,2.483,2.32,7.174,7.174,0,0,1,1.415,4.13C-349.543-103.179-349.539-103.152-349.536-103.127Zm-11.35.009h10.674c0-.055,0-.1,0-.137,0-.083,0-.167-.009-.25a6.537,6.537,0,0,0-1.01-3.051,8.681,8.681,0,0,0-2.607-2.568,2.363,2.363,0,0,1,0-3.98c.23-.156.462-.309.681-.48a7.184,7.184,0,0,0,2.833-4.4c.07-.369.089-.748.131-1.125h-10.685c0,.147-.009.285,0,.421a6.675,6.675,0,0,0,1.6,3.836,8.7,8.7,0,0,0,1.954,1.708,2.315,2.315,0,0,1,1.133,2.118,2.343,2.343,0,0,1-1.158,1.961,7.982,7.982,0,0,0-2.8,2.992A6.351,6.351,0,0,0-360.886-103.118Z"
                    transform="translate(362.224 120.773)"
                    :fill="bgTheme"
                  />
                  <path
                    id="Path_521"
                    data-name="Path 521"
                    d="M-305.95-42.852a6.091,6.091,0,0,1-1.291,1.7,11.046,11.046,0,0,1-1.251,1A3.167,3.167,0,0,0-309.9-38.2a.347.347,0,0,1-.044.07c-.019-.065-.033-.108-.044-.151a3.021,3.021,0,0,0-1.31-1.812,7.627,7.627,0,0,1-2.506-2.542c-.038-.065-.071-.132-.117-.219Z"
                    transform="translate(316.614 47.193)"
                    :fill="bgTheme"
                  />
                  <path
                    id="Path_522"
                    data-name="Path 522"
                    d="M-325.349,128.539a2.016,2.016,0,0,1,.681-1.013,6.9,6.9,0,0,1,2.346-1.227c.236-.081.475-.157.7-.259a1.687,1.687,0,0,0,.887-.787,2.415,2.415,0,0,0,1.54,1.027,7,7,0,0,1,2.343,1.19,2.1,2.1,0,0,1,.745,1.068Z"
                    transform="translate(327.403 -111.547)"
                    :fill="bgTheme"
                  />
                  <path
                    id="Path_523"
                    data-name="Path 523"
                    d="M-248.053,59.656a1.952,1.952,0,0,1,.014-.206.282.282,0,0,1,.3-.259.28.28,0,0,1,.307.271,2.038,2.038,0,0,1,0,.392.284.284,0,0,1-.3.28.3.3,0,0,1-.311-.292,1.7,1.7,0,0,1,0-.186Z"
                    transform="translate(254.413 -49.165)"
                    :fill="bgTheme"
                  />
                  <path
                    id="Path_524"
                    data-name="Path 524"
                    d="M-247.381,89.58a2.013,2.013,0,0,1-.014.206.281.281,0,0,1-.3.259.28.28,0,0,1-.308-.271,2.054,2.054,0,0,1,0-.372.3.3,0,0,1,.3-.3.3.3,0,0,1,.312.293,1.667,1.667,0,0,1,0,.186Z"
                    transform="translate(254.374 -77.409)"
                    :fill="bgTheme"
                  />
                </g>
              </svg>
            </div>
            <div>Ends In:{{ time_left }}</div>
          </div>
          <!-- <img class="w50" src="@/assets/retention-banner.svg" v-else-if="isCheckIn"> -->
          <div
            style="
              overflow-x: scroll;
              overflow-y: visible;
              width: 100%;
              scrollbar-width: none;
            "
          >
            <milestone v-if="isCheckIn" :model="miles_stoneObj" @msData="getMsData"></milestone>
          </div>
          <div style="margin-bottom: 10px" class="invite-earn-content pos-rel" v-if="isGamification || isInviteEarn">
            <div class="text-large font-bold margin-bottom-10" v-if="isInviteEarn && !isGamification">
              Events
            </div>
            <div class="text-large font-bold margin-bottom-10" v-else-if="isInviteEarn && isGamification">
              Badge Level
            </div>
            <table class="invite-earn margin-bottom-10" v-if="isInviteEarn && !isGamification" style="width: 96%; margin: 0 auto">
              <thead class="font-bold bottom-border">
                <tr
                  :style="{
                    backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
                  }"
                >
                  <th class="padding-horizontal-10">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <img class="small-icon" src="@/assets/challenges_flyy.png" />
                      <span style="font-weight: 500; font-size: 12px">Tasks</span>
                    </div>
                  </th>
                  <th class="padding-horizontal-10">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        gap: 5px;
                      "
                    >
                      <img style="width: 17px; height: 17px" src="@/assets/avatar_flyy.png" />
                      <span style="font-weight: 500; font-size: 12px">You Win</span>
                    </div>
                  </th>
                  <th class="padding-horizontal-10" v-if="hasReferee">
                    <div
                      style="
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 0px 10px;
                      "
                    >
                      <img style="width: 17px; height: 17px" src="@/assets/group_flyy.png" />
                      <span style="font-weight: 500; font-size: 12px">Friend Wins</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="oe in offerData.offer_events" style="border-bottom: 1px solid #ffffff !important">
                  <td
                    class="padding-horizontal-15 text-left"
                    style="
                      padding-left: 5px;
                      border-bottom: 1px solid #ffffff;
                      font-size: 13px;
                    "
                  >
                    {{ oe.name }}
                  </td>
                  <td class="padding-horizontal-15" style="border-bottom: 1px solid #ffffff !important">
                    <div v-if="(oe.min_reward_referrer > 0 && oe.max_reward_referrer > 0) || oe.max_reward_referrer > 0">
                      <div class="margin-bottom-5">
                        <img class="extra-small-icon margin-right-5" :src="offerData.currency_icon_url" />
                        <span>{{ offerData.currency_label }}</span>
                      </div>
                      <button
                        class="radius-3 no-outline padding-0510"
                        :style="{
                          border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
                          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
                          borderRadius: '20px',
                          padding: '4px 8px',
                        }"
                        v-if="oe.min_reward_referrer == 0 && oe.max_reward_referrer > 0"
                      >
                        Upto
                        <span v-if="offerData.currency_label === 'Cash'">₹</span
                        >{{ formatReward(offerData.currency_label, oe.max_reward_referrer, false) }}
                      </button>
                      <button
                        class="radius-3 no-outline padding-0510"
                        style="width: 75px"
                        :style="{
                          border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
                          borderRadius: '20px',
                          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
                        }"
                        v-else-if="oe.min_reward_referrer === oe.max_reward_referrer"
                      >
                        <span v-if="offerData.currency_label === 'Cash'">₹</span>
                        {{ formatReward(offerData.currency_label, oe.max_reward_referrer, false)
                        }}<!--   <span v-if="offerData.currency_label !=='Cash'">{{offerData.currency_label}}</span> -->
                      </button>
                      <button
                        class="radius-3 no-outline padding-0510"
                        :style="{
                          border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
                          borderRadius: '20px',
                          padding: '4px 8px',
                          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
                        }"
                        v-else
                      >
                        <span v-if="offerData.currency_label === 'Cash'">₹</span
                        >{{ formatReward(offerData.currency_label, oe.min_reward_referrer, false) }}
                        -
                        <span v-if="offerData.currency_label === 'Cash'">₹</span
                        >{{ formatReward(offerData.currency_label, oe.max_reward_referrer, false) }}
                      </button>
                    </div>
                    <button class="radius-3 no-outline border-none" v-else>
                      --
                    </button>
                  </td>
                  <td style="border-bottom: 1px solid #ffffff !important" class="padding-horizontal-15" v-if="hasReferee">
                    <div v-if="oe.min_reward_referee !== 0 || oe.max_reward_referee !== 0">
                      <div class="margin-bottom-5">
                        <img class="extra-small-icon margin-right-5" :src="offerData.currency_icon_url" />
                        <span>{{ offerData.currency_label }}</span>
                      </div>
                      <button
                        class="radius-3 no-outline padding-0510"
                        :style="{
                          border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
                          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
                        }"
                        v-if="oe.min_reward_referee == 0 && oe.min_reward_referee > 0"
                      >
                        Upto
                        <span v-if="offerData.currency_label === 'Cash'">₹</span
                        >{{ formatReward(offerData.currency_label, oe.max_reward_referee, false) }}
                      </button>
                      <button
                        class="radius-3 no-outline padding-0510"
                        style="width: 75px"
                        :style="{
                          border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
                          borderRadius: '20px',
                          padding: '4px 8px',
                          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
                        }"
                        v-else-if="oe.min_reward_referee === oe.max_reward_referee"
                      >
                        <span v-if="offerData.currency_label === 'Cash'">₹</span>
                        {{ oe.max_reward_referee ? oe.max_reward_referee : 0 }}
                        <!--  <span v-if="offerData.currency_label !=='Cash'">{{offerData.currency_label}}</span>-->
                      </button>
                      <button
                        class="radius-3 no-outline padding-0510"
                        :style="{
                          border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
                          borderRadius: '20px',
                          padding: '4px 8px',
                          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
                        }"
                        v-else
                      >
                        <span v-if="offerData.currency_label === 'Cash'">₹</span
                        >{{ formatReward(offerData.currency_label, oe.min_reward_referee, false) }}
                        -
                        <span v-if="offerData.currency_label === 'Cash'">₹</span
                        >{{ formatReward(offerData.currency_label, oe.max_reward_referee, false) }}
                      </button>
                    </div>
                    <!-- <button
                      class="radius-3 bg-light no-outline border-none"
                      v-else
                    >
                      --
                    </button> -->
                    <button style="background-color: transparent !important" class="radius-3 no-outline border-none" v-else>
                      -
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="padding-vertical-10 invite-earn-with-gamification margin-bottom-10" v-if="isGamification">
              <div
                v-for="prize in offerData.offer_prizes"
                class="align-hor center-ver space-between margin-bottom-10 padding-bottom-10 bottom-border"
              >
                <div class="align-hor center-ver">
                  <div class="margin-right-10">
                    <img class="medium-icon" v-if="prize.badge_url" :src="prize.badge_url" />
                    <img class="medium-icon" v-else src="@/assets/medal.svg" />
                  </div>
                  <div class="text-left">
                    <div class="font-bold text-regular margin-bottom-5">
                      {{ prize.label }}
                    </div>
                    <div>For Referral {{ prize.min_ref }} to {{ prize.max_ref }}</div>
                  </div>
                </div>
                <div>
                  <div class="margin-bottom-5">
                    <img class="extra-small-icon margin-right-5" :src="offerData.currency_icon_url" />
                    <span>{{ offerData.currency_label }}</span>
                  </div>
                  <button
                    class="radius-3 no-outline padding-5"
                    :style="{
                      border: '1px solid ' + (isDarkTheme ? '#ffffff' : bgTheme),
                      backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
                      color: '#323232'
                    }"
                  >
                    {{ formatReward(offerData.currency_label, prize.min_win, false) }}
                    to
                    {{ formatReward(offerData.currency_label, prize.max_win, false) }}
                  </button>
                </div>
              </div>
            </div>
            <!--            <div class="text-smaller pull-right padding-vertical-10" v-if="isInviteEarn">Campaign ends on {{formattedDate(offerData.ends_at, false)}}</div>--><!--            <div class="text-smaller pull-right padding-vertical-10" v-if="isInviteEarn">Campaign ends on {{formattedDate(offerData.ends_at, false)}}</div>-->
          </div>
          <div v-if="isCheckIn && !offerData.event_id">
            <button
              class="custom-button small padding-10 radius-5 margin-bottom-30 text-large pointer text-uppercase"
              :style="{
                background: isDarkTheme ? buttonBGColor : bgTheme,
                color: isDarkTheme ? headingTextColor : '#ffffff'
              }"
              v-if="offerData.checked_in"
            >
              Checked in
            </button>
            <button
              class="custom-button small padding-10 radius-5 margin-bottom-30 text-large pointer text-uppercase"
              :style="{
                background: isDarkTheme ? buttonBGColor : bgTheme,
                color: isDarkTheme ? headingTextColor : '#ffffff'
              }"
              @click.stop.prevent="dailyCheckin(offerData)"
              v-else
            >
              Check in
            </button>
          </div>
          <div style="padding: 0px 10px" class="offer-details">
            <div style="margin-bottom: 15px; margin-top: 20px; font-size: 19px;" class=" font-bold padding-top-10">
              {{ offerData.offer_type_code.includes("daily_offer") ? "Rules" : "Offer Details" }}
            </div>
            <div class="text-left word-break" v-if="offerTerms.length > 0">
              <!--              <div class="margin-bottom-10" v-for="term in offerTerms" v-html="term"></div>-->
              <div
                class="margin-bottom-10 offer-terms-content"
                v-html="offerData.offer_terms"
                :style="{
                  color: isDarkTheme ? subHeadingTextColor : '#585957'
                }"
              ></div>
              <!-- <div
                class="margin-bottom-10"
                v-html="offerData.offer_terms"
                :style="{ color: subHeadingTextColor }"
              ></div> -->
            </div>
            <div v-else class="text-left word-break" :style="{ color: subHeadingTextColor }">
              <div class="margin-bottom-10" v-html="offerData.details"></div>
            </div>
          </div>
        </div>
      </div>

      <div
        :style="{
          backgroundColor: isDarkTheme ? topBgColor : bgTheme,
          color: isDarkTheme ? headingTextColorc : '#ffffff'
        }"
        class="top-border-light-grey padding-horizontal-10 pos-fixed pos-center-hor pull-down bg-light"
        v-if="isInviteEarn || isGamification || offerData.offer_type_code.includes('daily_offer')"
      >
        <div
          :style="{
            color: isDarkTheme ? headingTextColor : '#ffffff',
            fontSize: '14px'
          }"
          class="font-bold margin-bottom-10"
          v-if="isInviteEarn || isGamification"
        >
          Invite now
        </div>
        <div class="share align-hor center-ver center-hor" v-if="isInviteEarn || isGamification">
          <div class="share-action-button show-in-mobile pointer" v-if="is_invite_logo_visible" @click="getShareMsg(offerData.id, 'wa')">
            <img class="medium-icon margin-right-5" src="@/assets/share/whatsup.png" />
          </div>
          <div class="share-action-button show-in-mobile pointer" v-if="is_invite_logo_visible" @click="getShareMsg(offerData.id, 'fb')">
            <img class="semi-medium-icon margin-right-5" src="@/assets/share/fb.png" />
          </div>
          <div class="share-action-button show-in-mobile pointer" v-if="is_invite_logo_visible" @click="getShareMsg(offerData.id, 'tw')">
            <img class="semi-medium-icon margin-right-5" src="@/assets/share/tiw.png" />
          </div>
          <div class="share-action-button show-in-mobile pointer" v-if="is_invite_logo_visible" @click="getShareMsg(offerData.id, 'gm')">
            <img class="semi-medium-icon margin-right-5" src="@/assets/share/gmail.png" />
          </div>
          <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'cp')">
            <img class="semi-medium-icon margin-right-5" src="@/assets/share/copy.png" />
          </div>
        </div>
        <div v-if="offerData.offer_type_code.includes('daily_offer')" class="">
          <div class="share align-hor center-ver center-hor" style="margin: 12px 0">
            <button
              class="custom-button small text-light padding-10 radius-5 text-large pointer text-uppercase"
              style="padding: 7px 9px; min-width: 90px"
              @click="redirectFromChallenge(offerData.deeplink)"
              :style="{ background: bgTheme }"
            >
              {{ offerData.button_text || "Open" }}
            </button>
          </div>
        </div>
      </div>
      <div
        id="copied-toast"
        class="font-bold pos-fixed pos-center-hor pull-down"
        style="
          width: 100px;
          padding: 5px;
          border-radius: 10px;
          background: rgba(0, 0, 0, 0.3);
          margin-bottom: 70px;
          color: white;
          display: none;
        "
      >
        Link Copied
      </div>

      <div v-if="isEmpty(offerData)">
        <div class="bg-light radius-5 padding-20 margin-bottom-10 pos-rel">
          <div class="wrapper align-ver center-ver margin-bottom-5">
            <div class="comment animate bg-light-grey w10"></div>
            <div class="comment animate bg-light-grey margin-bottom-10 w10"></div>
          </div>
          <div class="padding-vertical-20 margin-bottom-10">
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey w85"></div>
            </div>
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey"></div>
            </div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-20">
            <div class="comment animate bg-light-grey w20"></div>
            <div class="comment animate bg-light-grey w20"></div>
          </div>
          <div class="padding-vertical-20 margin-bottom-20">
            <div class="align-hor center-ver space-between bottom-border padding-bottom-10">
              <div class="w20" v-for="$i in 3">
                <div class="wrapper align-hor center-hor">
                  <div class="comment animate bg-light-grey margin-bottom-5 w20 margin-right-5"></div>
                  <div class="comment animate bg-light-grey margin-bottom-5 w80"></div>
                </div>
              </div>
            </div>
            <div class="wrapper align-hor center-ver space-between bottom-border padding-horizontal-20" v-for="$i in 3">
              <div class="comment animate bg-light-grey w20"></div>
              <div class="comment animate bg-light-grey w20"></div>
              <div class="comment animate bg-light-grey w20"></div>
            </div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-20">
            <div class="comment animate bg-light-grey w20"></div>
            <div class="comment animate bg-light-grey w20"></div>
          </div>
          <div class="padding-vertical-20 margin-bottom-10" v-for="$1 in 2">
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey w85"></div>
            </div>
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="msData && msData.show_popup">
        <mile-stone-popper :model="msData"></mile-stone-popper>
      </div>

      <Drawer :maskClosable="true" :zIndex="1002" @close="toggle()" :closeable="true" :header-text="'Terms & Conditions'">
        <div v-if="open">
          <div
            v-html="replaceNewLine(offerData.tnc)"
            style="min-height: 100px; overflow-y: scroll"
            :style="windowWidth < 511 ? 'max-height: 350px;' : 'max-height: 250px;'"
            class="text-left"
          ></div>
          <div
            style="
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 14px 0;
            "
          >
            <div @click="acceptTnc" class="accept-btn text-uppercase" :style="{ background: bgTheme }">
              Accept
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import Milestone from "@/components/milestone";
import MilestoneDetailPopup from "@/components/milestone-detail-popup";
import Drawer from "@/components/drawer";
import CheckInIcon from "@/components/check-in-icon.vue";
import InviteIcon from "@/components/invite-icon.vue";
import GameZoneIcon from "@/components/game-zone-icon.vue";
import ChallengesIcon from "@/components/challenges-icon.vue";

export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader,
    milestone: Milestone,
    "mile-stone-popper": MilestoneDetailPopup,
    Drawer,
    CheckInIcon,
    InviteIcon,
    GameZoneIcon,
    ChallengesIcon
  },
  data() {
    return {
      headerData: {
        onlyHeader: true
      },
      is_checkin: false,
      is_invite_earn: false,
      is_invite_logo_visible: true,
      is_game_zone: false,
      is_challenge: false,
      offerData: {},
      offerTerms: [],
      hasReferee: false,
      windowWidth: window.screen.width,
      open: false,
      time_left: "",
      msData: null,
      miles_stoneObj: {}
    };
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.isDarkTheme && this.$store.state.sdkEvent.isDarkTheme) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.mainBgColor) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.shadowBgColor) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.buttonBGColor) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.topBgColor) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },

    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.headingTextColor) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (this.$store.state.sdkEvent && this.$store.state.sdkEvent.themeColors && this.$store.state.sdkEvent.themeColors.shadowBgColor) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    subHeadingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.subHeadingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.subHeadingTextColor;
      }
      return null; // fallback
    },

    isInviteEarn: function() {
      return this.is_invite_earn;
    },
    isCheckIn: function() {
      return this.is_checkin;
    },
    isGameZone: function() {
      return this.is_game_zone;
    },
    isChallenge: function() {
      return this.is_challenge;
    },
    time: () => {
      return this.time_left;
    }
  },
  methods: {
    getOfferDetails(id) {
      var self = this;
      var url = this.$store.getters.flyyDomain + "/v1/get_offer/" + id;
      var headers = this.$store.getters.headers;
      axios
        .get(url, {
          mode: "no-cors",
          headers: headers,
          params: {
            page: this.page
          }
        })
        .then(resp => {
          if (resp.data.success) {
            var offer = resp.data.offer;
            this.offerData = offer;
            this.showTime(this.offerData);
            var type = offer.offer_type_code;
            this.open = offer.show_tnc && !offer.tnc_accepted;
            if (type.includes("checkin")) {
              this.is_checkin = true;
              this.is_game_zone = false;
              this.is_invite_earn = false;
              this.is_challenge = false;
              this.$store.state.user.milestones = offer.milestones;
              offer.mile_stones = this.formatUserCheckins(offer);
              this.miles_stoneObj = offer;
            } else if (type.includes("invite") || type.includes("gamification")) {
              this.is_checkin = false;
              this.is_game_zone = false;
              this.is_invite_earn = true;
              this.is_challenge = false;
              if (type.includes("gamification")) {
                this.$store.state.hasGamification = true;
              } else {
                this.$store.state.hasGamification = false;
              }
            } else if (type.includes("game")) {
              this.is_checkin = false;
              this.is_game_zone = true;
              this.is_invite_earn = false;
              this.is_challenge = false;
            } else if (type.includes("daily_offer")) {
              this.is_checkin = false;
              this.is_game_zone = false;
              this.is_invite_earn = false;
              this.is_challenge = true;
            }

            if (offer.offer_events && offer.offer_events.length > 0) {
              var has_referee = offer.offer_events.filter(oe => {
                return oe.reward_referee === true;
              });
              this.hasReferee = has_referee.length > 0 ? true : false;
            }

            this.offerTerms = this.formatOfferTerms(offer.offer_terms);
            if (type.includes("invite")) {
              this.$store.state.headTitle = "Invite & Earn";
            } else if (type.includes("checkin")) {
              this.$store.state.headTitle = "Daily Checkin";
            } else {
              this.$store.state.headTitle = this.formatOfferTitle(type);
            }
            this.$store.state.showHeader = false;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    toggle() {
      this.back();
    },
    getMsData(ms) {
      this.msData = ms;
    },
    closeAndAccept() {
      this.open = !this.open;
    },
    acceptTnc() {
      var url = this.$store.getters.flyyDomain + "/accept_tnc/" + this.offerData.id;
      var headers = this.$store.getters.headers;
      axios
        .get(url, {
          mode: "no-cors",
          headers: headers
        })
        .then(resp => {
          if (resp.data) {
            this.open = resp.data.success;
            this.closeAndAccept();
          }
        });
    },
    async showTime(data) {
      let dateStr = data.ends_at;
      let timeleft = "";
      var d = new Date();
      var d2 = new Date(dateStr);
      var milSec = d2 - d;
      while (milSec > 0) {
        var d3 = new Date(milSec);
        let nrDays = Math.floor(d3 / 1000 / 60 / 60 / 24);
        let nrHours = Math.floor(d3 / 1000 / 60 / 60) % 24;
        let nrMin = Math.floor(d3 / 1000 / 60) % 60;
        let nrSec = Math.floor(d3 / 1000) % 60;
        nrHours = nrHours < 10 ? "0" + nrHours : nrHours;
        nrMin = nrMin < 10 ? "0" + nrMin : nrMin;
        nrSec = nrSec < 10 ? "0" + nrSec : nrSec;
        if (nrDays !== 0) {
          nrDays = nrDays < 10 ? "0" + nrDays + "d:" : nrDays + "d:";
        } else {
          nrDays = "";
        }
        timeleft = `${nrDays}${nrHours}h:${nrMin}m:${nrSec}s`;
        timeleft.replace("-", "");
        milSec -= 1000;
        this.time_left = timeleft;
        await this.sleep(1000);
      }
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  },
  created() {
    if (!this.isEmpty(this.$route.params)) {
      this.is_invite_logo_visible = this.$store.state.user.isShareButtonAvailable;

      // if(this.$route.query.checkinObj && this.$route.query.checkinObj.offer_type_code.includes('checkin')){

      //   this.miles_stoneObj=this.$route.query.checkinObj
      // }
      this.getOfferDetails(this.$route.params.id);
    }
  }
};
</script>

<style>
.currency-type {
  position: absolute;
  top: 10px;
  right: 10px;
}
.milestone-wrapper {
  overflow-y: visible;
  white-space: nowrap;
  /* background: #ffffff; */
  left: 0;
  right: 0;
  margin: 15px 0px;
}
.check-mark {
  display: inline-block;
  transform: rotate(45deg);
  width: 5px;
  height: 13px;
  border-bottom: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
}
.padding-bottom-60 {
  padding-bottom: 60px;
}
.invite-earn tr td {
  width: 90px;
}
.invite-earn tr td:first-child {
  width: 50px;
}
.accept-btn {
  padding: 7px 23px;
  border-radius: 7px;
  color: #ffffff;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  background: var(--bg-color);
}

/* Offer terms content styling - comprehensive styling for all nested elements */
.offer-terms-content * {
  line-height: 1.6 !important;
  list-style-type: none !important;
}

.offer-terms-content h1,
.offer-terms-content h2,
.offer-terms-content h3,
.offer-terms-content h4 {
  font-size: 16px !important;
  font-weight: 600 !important;
  margin: 5px !important;
}

.offer-terms-content p {
  margin: 0px !important;
  margin-left: 0px !important;
  font-size: 14px !important;
}

.offer-terms-content ul,
.offer-terms-content ol {
  padding-left: 0 !important;
}

.offer-terms-content li {
  position: relative !important;
  padding-left: 15px !important; /* Needed for dot */
  font-size: 14px;
}

/* Custom bullet */
.offer-terms-content li::before {
  content: "•";
  position: absolute;
  left: 0;
  top: -1px;
  font-size: 18px;
}
/* Custom bullet */
/* .offer-terms-content ul::before {
  content: "•";
  position: absolute;
  left: 0;
  top: -4px;
  font-size: 18px;
} */

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .invite-details-box {
    margin-top: -185px;
  }
  .medium-icon-1 {
    width: 25px;
  }

  .mb-img {
    margin-bottom: 5px;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .invite-details-box {
    margin-top: -185px;
  }
  .medium-icon-1 {
    width: 25px;
  }
  .mb-img {
    margin-bottom: 15px;
  }
}
</style>
